module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/view-print/view-print.component.css
// module id = ./src/app/view-print/view-print.component.css
// module chunks = main